import { inject, injectable } from 'inversify';
import type { CurrentClientUserRepositoryInterface } from '@client/entity/current-client-user/domain/repository/current-client-user.repository';
import { CurrentClientUserDependencyTypes } from '@client/entity/current-client-user/current-client-user.dependency-types';
import type { CurrentClientUserApiService } from '@client/entity/current-client-user/data/service/current-client-user.api-service';
import type { CurrentClientUserApiDataTransformer } from '@client/entity/current-client-user/data/transformer/current-client-user.api-data-transformer';
import type { CurrentClientUser } from '@client/entity/current-client-user/domain/model/current-client-user.model';

@injectable()
export class CurrentClientUserRepository implements CurrentClientUserRepositoryInterface {
  public constructor(
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserApiService)
    private readonly apiService: CurrentClientUserApiService,
    @inject(CurrentClientUserDependencyTypes.CurrentClientUserApiDataTransformer)
    private readonly currentClientUserApiDataTransformer: CurrentClientUserApiDataTransformer,
  ) {}

  public async fetchCurrentClientUser(): Promise<CurrentClientUser> {
    const response = await this.apiService.getCurrentClientUser();

    return this.currentClientUserApiDataTransformer.map(response.data);
  }
}
